/**
 * Stable per-browser visitor identifier.
 *
 * Stored in localStorage so a returning visitor keeps the same id. The id
 * is included with every analytics event and with the lead row at capture
 * time, which lets the owner see "this lead came back N times" after the
 * exchange completed.
 *
 * Privacy: this is a first-party random UUID, not a fingerprint. Cleared
 * by the user when they clear site data.
 */

const KEY = 'haphe_visitor_id';

export function getVisitorId(): string {
  if (typeof window === 'undefined') return '';
  try {
    const existing = window.localStorage.getItem(KEY);
    if (existing) return existing;
    const next = generateId();
    window.localStorage.setItem(KEY, next);
    return next;
  } catch {
    // Private mode / storage disabled — return a one-shot id so the event
    // still has a value, just not a sticky one.
    return generateId();
  }
}

function generateId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  // Fallback for environments without crypto.randomUUID
  return 'v_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
}
